import Vue from "vue";

// Set state variable to value, no logic
export const set = (state, content) => {
  state[content.var] = content.val;
  // console.log(
  //   `state.${content.var} set to ${
  //     JSON.stringify(content.val).length > 200
  //       ? JSON.stringify(content.val).substring(0, 200) + " ... (truncated)"
  //       : JSON.stringify(content.val)
  //   }`
  // );
};

export const setSelectedOptions = (state, content) => {
  Vue.set(state.selectedOptions, content.var, content.val);
  // console.log(
  //   `state.selectedOptions.${content.var} set to ${
  //     JSON.stringify(content.val).length > 200
  //       ? JSON.stringify(content.val).substring(0, 200) + " ... (truncated)"
  //       : JSON.stringify(content.val)
  //   }`
  // );
};

// Add value to state variable array, no logic
export const add = (state, content) => {
  state[content.var].push(content.val);
  // console.log(
  //   `${
  //     JSON.stringify(content.val).length > 200
  //       ? JSON.stringify(content.val).substring(0, 200) + " ... (truncated)"
  //       : JSON.stringify(content.val)
  //   } added to state.${content.var}`
  // );
};

export const remove = (state, content) => {
  state[content.var].splice(content.val, 1);
  // console.log(
  //   `${JSON.stringify(content.val)} removed from state.${content.var}`
  // );
};
